import React from 'react';
import Sticky from '@wix/da-shared-react/pkg/Sticky';
import SubNavBarDesktopInner from './SubNavBarDesktopInner';
import ErrorBoundary from '@wix/da-shared-react/pkg/ErrorBoundary';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';

import s from './SubNavBarDesktop.scss';

export const SubNavBarDesktop = props => {
  const unsticky = useFlag('unsticky_profile_subnav');
  // TODO if we merge unsticky_profile_subnav - remove isSticky prop from SubNavBarDesktopInner
  // and clean up redundant CSS.
  return (
    <div className={s['root']}>
      <ErrorBoundary debugComponent="SubNavBarDesktop">
        {unsticky ? (
          <SubNavBarDesktopInner isSticky={false} {...props} />
        ) : (
          <Sticky zIndex={parseInt(s['z-index'])} usePortal>
            {isSticky => (
              <SubNavBarDesktopInner isSticky={isSticky} {...props} />
            )}
          </Sticky>
        )}
      </ErrorBoundary>
    </div>
  );
};

export default SubNavBarDesktop;
